import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { GlyphStamp, type GlyphName } from './Glyph';

interface Props {
  to: string;
  title: string;
  objective: string;
  glyph?: GlyphName;
  lessonCount: number;
  doneCount?: number;
  className?: string;
  proOnly?: boolean;
}

export default function PathCard({ to, title, objective, glyph, lessonCount, doneCount, className = '', proOnly = false }: Props) {
  const showProgress = typeof doneCount === 'number';
  return (
    <Link
      to={to}
      className={`block bg-white border border-ink-100 rounded-2xl p-6 sm:p-7 hover:border-ink-400 transition group ${className}`}
    >
      <div className="flex items-start gap-4 mb-4">
        {glyph && <GlyphStamp glyph={glyph} size={44} />}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-ink-500">Path</div>
            {proOnly && (
              <span className="text-[10px] uppercase tracking-wider bg-ink-900 text-warm-50 px-1.5 py-0.5 rounded-full">Pro</span>
            )}
          </div>
          <h3 className="font-display text-2xl leading-tight">{title}</h3>
        </div>
      </div>
      <p className="text-ink-600 leading-relaxed mb-5">{objective}</p>
      <div className="flex items-center justify-between text-sm text-ink-500">
        <span>
          {showProgress ? `${doneCount} of ${lessonCount} lessons` : `${lessonCount} lessons`}
        </span>
        <span className="inline-flex items-center gap-1 text-ink-900 group-hover:gap-2 transition-all">
          {showProgress && doneCount! > 0 ? 'Continue' : 'Start'}
          <ArrowRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
}
